/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";

import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import * as questionIds from "./questionIds";

const enablePPQAutomation = getFeatureToggles()[FeatureToggleNames.EnablePPQAutomation];

const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.LineManagerName,
        questionText: "Line Manager's Name",
        canBeDisabled: false
    },
    {
        id: questionIds.LineManagerEmail,
        questionText: "Line Manager Email",
        canBeDisabled: false
    },
    {
        id: questionIds.PurchaseOrderNumber,
        questionText: "Purchase Order Number",
        canBeDisabled: true,
        disabled: true
    },
    {
        id: questionIds.ReferredTitle,
        questionText: "Title",
        canBeDisabled: true
    },
    {
        id: questionIds.ReferredFirstName,
        questionText: "First Name",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredLastName,
        questionText: "Last Name",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredDob,
        questionText: "Date of Birth",
        canBeDisabled: false
    },
    {
        id: questionIds.PersonalEmailAddress,
        questionText: "Email (Work or Personal)",
        canBeDisabled: false
    },
    {
        id: questionIds.ConfirmPersonalEmailAddress,
        questionText: "Confirm email address",
        canBeDisabled: false
    },
    {
        id: questionIds.Postcode,
        questionText: "Postcode",
        canBeDisabled: false
    },
    {
        id: questionIds.JobTitle,
        questionText: "Job Role/Title",
        canBeDisabled: true
    },
    {
        id: questionIds.FullPartTime,
        questionText: "Full-Time/Part-Time",
        canBeDisabled: true
    },
    {
        id: questionIds.EmployeeId,
        questionText: "Employee Unique ID",
        canBeDisabled: true
    },
    {
        id: questionIds.AnticipatedStartDate,
        questionText: "Anticipated Start Date",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel1Name,
        questionText: "Org Level 1",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel2Name,
        questionText: "Org Level 2",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel3Name,
        questionText: "Org Level 3",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel4Name,
        questionText: "Org Level 4",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkGroups,
        questionText: "Work Groups",
        canBeDisabled: true,
        disabled: true
    },
    {
        id: questionIds.EvidenceOfCovid19VaccinationStatusMandatory,
        questionText: "Evidence of COVID-19 Vaccination status is mandatory for role",
        canBeDisabled: true
    },
    {
        id: questionIds.ExposureProneProcedure,
        questionText: "Exposure Prone Procedure (EPP) Work",
        canBeDisabled: true
    },
    {
        id: questionIds.RegularPatientContact,
        questionText: "Direct Patient Care or Regular Patient Contact / Contact with Clinical Specimens or Pathogens / Pathology Work",
        canBeDisabled: true
    },
    {
        id: questionIds.ProlongedRepetitiveMovements,
        questionText: "Prolonged Repetitive Movements / Actions",
        canBeDisabled: true
    },
    {
        id: questionIds.HeavyLoads,
        questionText: "Moving or handling heavy loads",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingShifts,
        questionText: "Working shifts",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingNights,
        questionText: "Working nights",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingDustFumes,
        questionText: "Working with dust or fumes",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingIrritants,
        questionText: "Working with skin irritants / sensitisers",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingChemicals,
        questionText: "Working with chemicals (industrial or cleaning)",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingConfinedSpace,
        questionText: "Working in a confined space",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingVibratingMachinery,
        questionText: "Working with vibrating machinery / tools",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingHeights,
        questionText: "Working at Heights",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingWithSewage,
        questionText: "Working with Sewage",
        canBeDisabled: true
    },
    {
        id: questionIds.LoneWorking,
        questionText: "Lone Working",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingOutside,
        questionText: "Working Outside",
        canBeDisabled: true
    },
    {
        id: questionIds.ExposureToNoiseLevels,
        questionText: "Exposure to Noise Levels (>80dbA)",
        canBeDisabled: true
    },
    {
        id: questionIds.FoodHandling,
        questionText: "Food Handling",
        canBeDisabled: true
    },
    {
        id: questionIds.DrivingDuties,
        questionText: "Driving Duties",
        canBeDisabled: true
    },
    {
        id: questionIds.DrivingLGV,
        questionText: "Driving LGV or PCVs",
        canBeDisabled: true
    },
    {
        id: questionIds.DrivingForkliftTrucks,
        questionText: "Driving forklift Trucks",
        canBeDisabled: true
    },
    {
        id: questionIds.VocationalDriving,
        questionText: "Vocational Driving",
        canBeDisabled: true
    },
    {
        id: questionIds.VocationalDrivingLevel,
        questionText: "Please state level",
        canBeDisabled: true
    },
    {
        id: questionIds.ConfirmJobFamily,
        questionText: "As an alternative to ticking the hazards above please confirm the pre-defined Job Family/Group that this role falls under here",
        canBeDisabled: true
    },
    {
        id: questionIds.OtherHealthSurveillanceChecks,
        questionText: "Please list any other Health Surveillance checks required by legislation (e.g. COSHH) / any Statutory Medical Surveillance (e.g. Asbestos, Lead)",
        canBeDisabled: true
    },
    {
        id: questionIds.ContactWithLatex,
        questionText: "Contact with latex",
        canBeDisabled: true
    },
    {
        id: questionIds.ContactWithCytotoxics,
        questionText: "Contact with cytotoxics",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkingWithChildren,
        questionText: "Working with children",
        canBeDisabled: true
    },
    {
        id: questionIds.ExposureToChallengingOrAggressiveBehaviour,
        questionText: "Exposure to persons with challenging or aggressive behaviour",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19RiskAssessment,
        questionText: "Ask the Candidate to complete a COVID-19 Risk Assessment",
        canBeDisabled: true
    }
];

if (enablePPQAutomation) {
    masterConfig.push({
        id: questionIds.WorkWithVdus,
        questionText: "Work with DSE (>5hrs per week)",
        canBeDisabled: true
    });
} else {
    masterConfig.push({
        id: questionIds.WorkWithVdus,
        questionText: "Work with VDUs (>5hrs per week)",
        canBeDisabled: true
    });
}
/* eslint-enable max-len */

export { masterConfig };
